export const M3_LOGO: string = require('../img/Logo-Fin-large-W.png');
export const M_LOGO: string = require('../img/Logo-M.png');
export const LOG_IN_PIC: string = require('../img/Title-image.png');

export const SIDEBAR_HOVER_MEMBERS_ICON: string = require('../img/icons/hover/Members.png');
export const SIDEBAR_HOVER_ATTENDANCES_ICON: string = require('../img/icons/hover/Attendances.png');
export const SIDEBAR_HOVER_PROGRAMS_ICON: string = require('../img/icons/hover/Programs.png');
export const SIDEBAR_HOVER_PACKAGES_ICON: string = require('../img/icons/hover/Packages.png');
export const SIDEBAR_HOVER_MEMBERSHIP_PAYMENTS_ICON: string = require('../img/icons/hover/Payment.png');
export const SIDEBAR_HOVER_POS_ICON: string = require('../img/icons/hover/POS.png');
export const SIDEBAR_HOVER_STAFF_ICON: string = require('../img/icons/hover/Staffs.png');
export const SIDEBAR_HOVER_LIST_ICON: string = require('../img/icons/hover/List.png');
export const SIDEBAR_HOVER_HISTORY_ICON: string = require('../img/icons/hover/History.png');
export const SIDEBAR_HOVER_REPORT_ICON: string = require('../img/icons/hover/Report.png');
export const SIDEBAR_HOVER_LEADS_ICON: string = require('../img/icons/hover/Leads.png');
export const SIDEBAR_HOVER_EMAIL_TEMPLATE_ICON: string = require('../img/icons/hover/EmailTemplate.png');

export const SIDEBAR_IDLE_MEMBERS_ICON: string = require('../img/icons/idle/Members.png');
export const SIDEBAR_IDLE_ATTENDANCES_ICON: string = require('../img/icons/idle/Attendances.png');
export const SIDEBAR_IDLE_PROGRAMS_ICON: string = require('../img/icons/idle/Programs.png');
export const SIDEBAR_IDLE_PACKAGES_ICON: string = require('../img/icons/idle/Packages.png');
export const SIDEBAR_IDLE_MEMBERSHIP_PAYMENTS_ICON: string = require('../img/icons/idle/Payment.png');
export const SIDEBAR_IDLE_POS_ICON: string = require('../img/icons/idle/POS.png');
export const SIDEBAR_IDLE_STAFF_ICON: string = require('../img/icons/idle/Staffs.png');
export const SIDEBAR_IDLE_LIST_ICON: string = require('../img/icons/idle/List.png');
export const SIDEBAR_IDLE_HISTORY_ICON: string = require('../img/icons/idle/History.png');
export const SIDEBAR_IDLE_REPORT_ICON: string = require('../img/icons/idle/Report.png');
export const SIDEBAR_IDLE_LEADS_ICON: string = require('../img/icons/idle/Leads.png');
export const SIDEBAR_IDLE_EMAIL_TEMPLATE_ICON: string = require('../img/icons/idle/EmailTemplate.png');

export const SIDEBAR_MAX_WIDTH = 205;


// WEBPACK FOOTER //
// ./src/navigation/Constants.tsx